var _a;
import { useMemo } from 'react';
import { Environment, getEnvironment, getUnleashEnvironment } from '../internal/getEnvironment';
export var CLIENT_KEYS = (_a = {},
    _a[Environment.Local] = '[]:ED.7262a863cbe0e8321619f4d987316ad2b70cea6f4459dd8ecebcd411',
    _a[Environment.Development] = '[]:ED.7262a863cbe0e8321619f4d987316ad2b70cea6f4459dd8ecebcd411',
    _a[Environment.Staging] = '[]:Stage.7995add709415d66710dd7ce151e2792cd38151b264090f90a7e634d',
    _a[Environment.Production] = '[]:Production.96ffe11bb3a9f18a6d5fcfa993e8025999ebba1162fdb973ec663aba',
    _a);
export var useUnleashConfig = function () {
    var environment = useMemo(function () { return getEnvironment(); }, []);
    var unleashEnvironment = useMemo(function () { return getUnleashEnvironment(environment); }, [environment]);
    var clientKey = useMemo(function () { return CLIENT_KEYS[environment]; }, [environment]);
    var config = useMemo(function () { return ({
        url: 'https://api.jive.com/feature-flags-edge/v1/api/frontend',
        clientKey: clientKey,
        refreshInterval: 300,
        appName: 'GoTo Admin',
        environment: unleashEnvironment,
    }); }, [clientKey, unleashEnvironment]);
    return config;
};
//# sourceMappingURL=useUnleashConfig.js.map